// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { RegisterGuestParams } from './types'

const API_BASE = process.env.REACT_APP_API_BASE;
const API_V1 = `${API_BASE}/v1/`;

// Type safe error handling ref.: https://redux-toolkit.js.org/rtk-query/usage-with-typescript#using-auto-generated-react-hooks

// Define a service using a base URL and expected endpoints
export const preLaunchBackendApi = createApi({
  reducerPath: 'preLaunchApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_V1 }),
  endpoints: (builder) => ({
    registerGuest: builder.mutation<{}, RegisterGuestParams>({
      query: ({ email }) => ({
        url: 'launch_notification/guests',
        method: 'POST',
        body: { email },
      }),
      transformErrorResponse: (err) => {
        let message = '';

        switch (err?.status) {
          case 409:
            message = "Looks like you're already on the list!";
            break;
          case 422:
            message = 'Please check email format.';
            break;
          case 429:
            message = 'Your network is sending too many requests. Please try again later.';
            break;
          default:
            message = 'Please try again later.';
            break;
        }

        return Object.assign({}, err, { data: { message } });
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useRegisterGuestMutation } = preLaunchBackendApi;
